import React from "react";
import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./App/protected.route";
import { LoginContainer } from "./views/login/login.container";
import { RegisterContainer } from "./views/register/register.container";
import { ForgetContainer } from "./views/forget-password/forget.container";
import { ProductContainer } from "./views/product/product.container";
import { CategoryContainer } from "./views/category/category.container";
import { HomeContainer } from "./views/home/home.container";
import { CartContainer } from "./views/cart/cart.container";
import { AffiliateContainer } from "./views/affiliate/affiliate.container";
import { AffiliateLoginContainer } from "./views/affiliate-login/affiliate-login.container";
import { AffiliateDashboardContainer } from "./views/affiliate-dashboard/affiliate-dashboard.container";
import { AffiliateForgetContainer } from "./views/affiliate-forget-password/affiliate-forget.container";
import { AffiliateResetPasswordContainer } from "./views/affiliate-reset-password/affiliate-reset-password.container";
import { ContactContainer } from "./views/contact/contact.container";
import { CheckoutContainer } from "./views/checkout/checkout.container";
import { ThankYouContainer } from "./views/thank-you/thank-you.container";
import { PaymentVerifyContainer } from "./views/payment-verify/payment-verify.container";
import { GalleryContainer } from "./views/gallery/gallery.container";
import { ResetPasswordContainer } from "./views/reset-password/reset-password.container";
import { ProfileContainer } from "./views/profile/profile.container";
import { OrdersContainer } from "./views/orders/orders.container";
import { OrderContainer } from "./views/order/order.container";
import { UpdatePasswordContainer } from "./views/update-password/update-password.container";
import { WishlistContainer } from "./views/wishlist/wishlist.container";
import { CmsContainer } from "./views/cms/cms.container";
import { ProductsContainer } from "./views/products/products.container";
import { FaqPage } from "./views/faq/faq.component";

export const RoutePath = () => (
  <Routes>
    <Route path="/" element={<HomeContainer />} />
    <Route path="/products" element={<ProductsContainer />} />
    <Route path="/faq" element={<FaqPage />} />
    <Route path="/login" element={<LoginContainer />} />
    <Route path="/register" element={<RegisterContainer />} />
    <Route path="/cart" element={<CartContainer />} />
    <Route path="/forget-password" element={<ForgetContainer />} />
    <Route path="/category/:slug" element={<CategoryContainer />} />
    <Route path="/page/:slug" element={<CmsContainer />} />
    <Route path="/product/:slug" element={<ProductContainer />} />
    <Route path="/become-an-affiliate" element={<AffiliateContainer />} />
     <Route path="/affiliate-login" element={<AffiliateLoginContainer />} />
     <Route path="/affiliate-dashboard" element={<AffiliateDashboardContainer />} />
     <Route path="/affiliate-forget-password" element={<AffiliateForgetContainer />} />
     <Route path="/affiliate-reset-password/:token" element={<AffiliateResetPasswordContainer />} />
     <Route path="/contact-us" element={<ContactContainer />} />
    <Route
      path="/checkout"
      element={
        <ProtectedRoute>
          <CheckoutContainer />
        </ProtectedRoute>
      }
    />
    <Route path="/gallery" element={<GalleryContainer />} />
    <Route path="/payment-verify" element={<PaymentVerifyContainer />} />
    <Route path="/order-success/:id" element={<ThankYouContainer />} />
    <Route path="/reset-password/:token" element={<ResetPasswordContainer />} />
    <Route
      path="/profile"
      element={
        <ProtectedRoute>
          <ProfileContainer />
        </ProtectedRoute>
      }
    />
    <Route
      path="/orders"
      element={
        <ProtectedRoute>
          <OrdersContainer />
        </ProtectedRoute>
      }
    />
    <Route
      path="/order/:id"
      element={
        <ProtectedRoute>
          <OrderContainer />
        </ProtectedRoute>
      }
    />
    <Route
      path="/update-password"
      element={
        <ProtectedRoute>
          <UpdatePasswordContainer />
        </ProtectedRoute>
      }
    />
    <Route
      path="/wishlist"
      element={
        <ProtectedRoute>
          <WishlistContainer />
        </ProtectedRoute>
      }
    />
  </Routes>
);
